import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/site';
import { topics } from '@/mocks/topics';

export default function Footer() {
  const hotTopics = topics.slice(0, 4);

  return (
    <footer className="bg-secondary-950 text-background-50">
      <div className="max-w-content mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:pr-6">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-secondary-950">
                <i className="ri-newspaper-line text-xl" />
              </span>
              <span className="font-heading text-xl font-bold">{siteInfo.name}</span>
            </div>
            <p className="text-sm leading-relaxed text-background-200/90">
              {siteInfo.slogan}。专注热门爆料与网络热点的深度整理，做长期可回看的专题资源库。
            </p>
            <p className="mt-4 text-sm text-background-200/80 flex items-center gap-2">
              <i className="ri-mail-line text-accent-400" />
              {siteInfo.email}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base mb-4 text-accent-400">主题分类</h4>
            <ul className="flex flex-col gap-2.5">
              {categories.map((c) => (
                <li key={c.id}>
                  <Link
                    to={`/library?cat=${c.id}`}
                    className="text-sm text-background-200/90 hover:text-accent-400 transition-colors"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base mb-4 text-accent-400">热门专题</h4>
            <ul className="flex flex-col gap-2.5">
              {hotTopics.map((t) => (
                <li key={t.id}>
                  <Link
                    to={`/topic/${t.id}`}
                    className="text-sm text-background-200/90 hover:text-accent-400 transition-colors line-clamp-1"
                  >
                    {t.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base mb-4 text-accent-400">站内导航</h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-sm text-background-200/90 hover:text-accent-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/library" className="text-sm text-background-200/90 hover:text-accent-400 transition-colors">
                  资源库全集
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-200/90 hover:text-accent-400 transition-colors">
                  关于我们
                </Link>
              </li>
              <li className="text-sm text-background-200/80 flex items-center gap-2 pt-1">
                <i className="ri-time-line text-accent-400" />
                {siteInfo.workTime}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-200/70">
            © {new Date().getFullYear()} {siteInfo.name} · 内容整理仅供参考，转载请注明来源
          </p>
          <p className="text-xs text-background-200/70">自 {siteInfo.since} 年持续整理热门专题</p>
        </div>
      </div>
    </footer>
  );
}